<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;">系统设置</span> / 基础设置
    </div>
    <div class="container">
      <div class="basic-settings-body">
        <div>
          <div>
            <p class="create-campus">
              <el-button size="mini" type="primary" @click="createPayAccount">添加收款账户</el-button>
            </p>
            <div style="margin-top:20px;">
              <el-table size="small" :data="PayAccountList" :header-cell-style="{ background: '#f5f7fa', color: '#909399', 'font-size': '14px' }" stripe style="width: 100%">
                <!-- <el-table-column type="selection" width="55">
                      </el-table-column> -->
                <el-table-column fixed="left" width="50" align="center" label="序号">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="账户名称"></el-table-column>

                <el-table-column label="所属校区" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span v-for="item of scope.row.campusAccountAutArr" :key="item.id">【{{
                                            item.campusName
                                        }}】</span>
                  </template>
                </el-table-column>

                <el-table-column prop="type" label="类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.type == '1'">现金</span>
                    <span v-if="scope.row.type == '2'">银行存款</span>
                    <span v-if="scope.row.type == '3'">虚拟货币</span>
                  </template>
                </el-table-column>

                <el-table-column prop="remark" label="备注"></el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="editAccount(scope.row)">编辑</el-button>

                    <el-popconfirm title="确定要删除该账户吗？" @confirm="
                                            deleteEducationalInstitutionAccount(scope.row.id)
                                            ">
                      <el-button slot="reference" style="margin-left: 10px" type="text" size="small">删除</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

        </div>
      </div>
      <el-dialog title="新建校区" :visible.sync="centerDialogVisible" width="50%">
        <el-form size="mini" :inline="true" class="form-style">
          <el-form-item label="分校区名称" required>
            <el-input v-model="educational_institution_campus_name" placeholder="请输入校区名称" style="width: 400px">
            </el-input>
          </el-form-item>

          <el-form-item label="分校教师数" required>
            <el-input-number style="width: 200px" v-model="campus_teacher_num" :min="1" label="请输入分校最大教师数">
            </el-input-number>

            <span style="margin-left: 10px">(剩余名额:{{ off_teacher_num }})</span>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="centerDialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="save">保 存</el-button>
        </span>
      </el-dialog>
      <el-dialog title="编辑分校" :visible.sync="editDialogVisible" width="50%">
        <el-form size="mini" :inline="true" class="form-style">
          <el-form-item label="分校区名称" required>
            <el-input v-model="edit_educational_institution_campus_name" placeholder="请输入校区名称" style="width: 400px">
            </el-input>
          </el-form-item>

          <el-form-item label="分校教师数" required>
            <el-input-number style="width: 200px" v-model="campus_teacher_num" :min="1" label="请输入分校最大教师数">
            </el-input-number>

            <span style="margin-left: 10px">(剩余名额:{{ off_teacher_num }})</span>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="editDialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="editEducationalInstitutionCampusName">保 存</el-button>
        </span>
      </el-dialog>

      <el-dialog width="80%" :title="'授权课程: ' + current_coursetitle" :visible.sync="dialogTableVisible">
        <el-table size="mini" :data="SchoolAutherData" style="width: 100%" max-height="250">
          <el-table-column fixed prop="name" label="校区名称" width="150">
          </el-table-column>

          <el-table-column prop="province" label="授权价格(单位:元)">
            <template slot-scope="scope">
              <span v-if="scope.row.campusAuth">{{
                                scope.row.campusAuth.price
                            }}</span>
            </template>
          </el-table-column>

          <el-table-column label="授权状态">
            <template slot-scope="scope">
              <span v-if="scope.row.campusAuth">已授权</span>
              <span v-else>未授权</span>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">

              <el-button v-if="scope.row.campusAuth" type="text" size="small" @click="addOrDeleteCurriculumAuth('2', scope.row.id)">
                取消授权
              </el-button>

              <el-button v-if="!scope.row.campusAuth" @click="addOrDeleteCurriculumAuth('1', scope.row.id)" type="text" size="small">
                授权
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <!--修改课程价格-->
      <el-dialog title="修改价格" :visible.sync="dialogFormVisible">
        <el-form size="mini" :model="form">
          <el-form-item label="课程价格(单位:元)">
            <el-input-number placeholder="请输入课程价格" v-model="form.curriculum_price" :min="0" :controls="false" :precision="2"></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="updateSchoolCurriculumPermissionPrice">确 定</el-button>
        </div>
      </el-dialog>

      <!--修改课程授权价格-->
      <el-dialog title="设置授权价格" :visible.sync="dialogFormVisible1">
        <el-form size="mini">
          <el-form-item label="课程价格(单位:元)">
            <el-input-number placeholder="请输入课程的授权价格" v-model="author_price" :min="0" :controls="false" :precision="2">
            </el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogFormVisible1 = false">取 消</el-button>
          <el-button size="small" type="primary" @click="addOrDeleteCampusCurriculumAuth('1')">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="curriculum_title" :visible.sync="dialogVisible" width="80%">
        <el-table :data="curriculumMaterialList" :header-cell-style="{ background: '#f5f7fa' }" size="mini">
          <el-table-column width="100" align="center" label="讲次序号">
            <template slot-scope="scope"> 第{{ scope.$index + 1 }}讲 </template>
          </el-table-column>

          <el-table-column align="center" width="100" prop="id" label="缩略图">
            <template slot-scope="scope">
              <el-image style="width: 60px; height: 45px" :src="scope.row.img_url" fit="cover"></el-image>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="title" label="讲次名称"></el-table-column>

          <el-table-column align="center" prop="desc" label="简介"></el-table-column>

          <el-table-column width="100" align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="prepare(scope.row.id)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>
  
<script>
import {
  addEducationalInstitutionCampus,
  getEducationalInstitutionCampusList,
  editEducationalInstitutionCampusName,
  deleteEducationalInstitutionCampus,
  getBaseInfo,
  addStopDay,
  addClassDay,
  updateIsEncryption,
  getSchoolCurriculumList,
  getSchoolCampusCurriculumAuthData,
  updateSchoolCurriculumPermissionPrice,
  addOrDeleteCampusCurriculumAuth,
  getEducationalInstitutionAccountList,
  getGoodsList,
  deleteGoods,
  deleteEducationalInstitutionAccount,
  getSchoolRightInfo,
  wechatAgentGetPreAuthUrl,
} from "@/api/educational";
import { getZoneSchoolSubjectList } from "@/api/community";
import { getHomepage } from "@/api/homeset";

export default {
  name: "basicSettings",
  data() {
    return {
      form1: {
        name: "",
      },

      goodsList: [],
      currentPage: 1,

      curriculum_title: "", //讲次名称
      dialogVisible: false, //讲次详情列表
      curriculumMaterialList: [], //讲次数据列表

      //更新课程体系价格
      form: {
        curriculum_id: "",
        curriculum_price: "0",
      },

      form2: {
        educational_institution_campus_id: "",
        curriculum_id: "",
        price: "",
      },

      //校区课程体系权限详情
      SchoolAutherData: [],
      author_price: "",

      //修改课程价格
      dialogFormVisible: false,
      dialogFormVisible1: false,

      //授权课程title
      current_coursetitle: "",

      data: [
        {
          key: 1,
          label: "河西分校河西分校河西分校",
          price: "3699",
        },
        {
          key: 2,
          label: "津南分校",
          price: "1699",
        },
      ],
      value: [],

      tableName: [], //数据表名
      transferData: [], //Transfer 的数据源	array[{ key, label, disabled }]
      checked: [], //穿梭框绑定的数据，选定到右侧框中的数据项的value组成的数组

      dialogTableVisible: false,
      tableData: [
        {
          name: "Jrcode体验课",
          name1: "jrcode",
          price: "3699",
          num: "32",
        },
      ],
      campusTableData: [],
      centerDialogVisible: false,
      editDialogVisible: false,
      educational_institution_campus_name: "",
      edit_educational_institution_campus_name: "",

      campus_teacher_num: 0, //可分配最大教师数

      edit_id: "",
      editableTabsValue: "1",
      editStopDayShow: false,
      educational_institution_closing_day_list: [
        {
          closing_date: "",
          name: "",
        },
      ],
      educational_institution_class_day_list: [],
      is_encryption: false,
      classtime: null,

      //校区账户列表
      PayAccountList: [],

      activeMenu: "1", //激活的菜单

      //校区权益
      schoolStuNum: 0,
      schoolTchNum: 0,
      campusNum: 0,
      schoolInfo: {
        max_campus_num: 0,
        max_student_num: 0,
        max_teacher_num: 0,
        off_time: "",
        name: "",
        domain: "",
      },

      //课程查询
      ruleForm: {
        teaching_type: "",
        curriculum_type: "",
        subject_id: "",
      },
      subjectList: [], //科目列表

      page_no: 1,
      page_size: 20,
      total: 0,

      page_no1: 1,
      page_size1: 20,
      total1: 0,

      //公众号授权
      OfficialAccount: {
        name: "",
        qrcode: "",
        headimgurl: "",
        is_authorize: false,
        authorizer_service_type_info: "", //公众号类型
        authorizer_verify_type_info: "", //认证状态
      },

      updateform: {
        start_time: "",
        end_time: ""
      }

    };
  },
  mounted() {
    this.getEducationalInstitutionAccountList();


  },


  computed: {
    off_teacher_num() {
      var num = 0;
      for (let k = 0; k < this.campusTableData.length; k++) {
        num = this.campusTableData[k].max_teacher_num + num;
      }

      return this.schoolInfo.max_teacher_num - num;
    },
  },

  methods: {
    //微信公众号授权
    WeixinAuth() {
      console.log("微信公众号授权");
      this.wechatAgentGetPreAuthUrl();
    },

    DownLoadQrcode() {
      window.open(this.OfficialAccount.qrcode, "_blank");
    },

    //获得校区信息
    getHomepage() {
      getHomepage().then((res) => {
        console.log("校区信息");
        console.log(res);
        this.schoolInfo = res.schoolInfo;
        if (this.schoolInfo.is_authorize) {
          this.OfficialAccount.name = this.schoolInfo.authorizer_nick_name;
          this.OfficialAccount.qrcode = this.schoolInfo.authorizer_qrcode_url;
          this.OfficialAccount.headimgurl = this.schoolInfo.authorizer_head_img;
          this.OfficialAccount.is_authorize = this.schoolInfo.is_authorize;
          this.OfficialAccount.authorizer_verify_type_info =
            this.schoolInfo.authorizer_verify_type_info;
          this.OfficialAccount.authorizer_service_type_info =
            this.schoolInfo.authorizer_service_type_info;
        }
      });
    },

    wechatAgentGetPreAuthUrl() {
      wechatAgentGetPreAuthUrl().then((res) => {
        console.log("跳转授权链接");
        console.log(res);
        window.location.href = res.url;
      });
    },

    //查询校区科目权限
    getZoneSchoolSubjectList() {
      getZoneSchoolSubjectList().then((res) => {
        console.log("获得校区科目列表");
        console.log(res);
        this.subjectList = res.subjectList;
      });
    },

    //获取校区权益信息
    getSchoolRightInfo() {
      getSchoolRightInfo().then((res) => {
        console.log("校区权益数据");
        console.log(res);
        this.campusNum = res.campusNum;
        this.schoolInfo = res.schoolInfo;
        this.schoolStuNum = res.schoolStuNum;
        this.schoolTchNum = res.schoolTchNum;
        this.schoolSubjectList = res.schoolSubjectList;
      });
    },

    //课程授权

    CourseAuthor(title, id, price) {
      this.dialogTableVisible = true;
      this.current_coursetitle = title;
      this.form2.curriculum_id = id;
      this.author_price = price;

      this.getSchoolCampusCurriculumAuthData(id);
    },

    //授权或取消授权操作
    addOrDeleteCurriculumAuth(cmd, id) {
      if (cmd == "1") {
        console.log("授权操作");
        this.form2.educational_institution_campus_id = id;
        this.dialogFormVisible1 = true;
      } else {


        this.$confirm("确定取消该课程授权吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          console.log("取消授权");
          this.form2.educational_institution_campus_id = id;
          this.addOrDeleteCampusCurriculumAuth("2");
        });




      }
    },

    //授权课程给校区
    addOrDeleteCampusCurriculumAuth(operate) {
      addOrDeleteCampusCurriculumAuth({
        educational_institution_campus_id:
          this.form2.educational_institution_campus_id,
        curriculum_id: this.form2.curriculum_id,
        price: this.author_price,
        operate: operate, //1添加  2删除
      }).then((res) => {
        console.log("授权课程");
        console.log(res);
        if (res.is_create) {
          this.getSchoolCampusCurriculumAuthData(this.form2.curriculum_id);
          this.dialogFormVisible1 = false;
          this.$message.success("授权成功");
          this.getSchoolCurriculumList();
        }

        if (res.is_delete) {
          this.getSchoolCampusCurriculumAuthData(this.form2.curriculum_id);
          this.$message.success("取消授权成功");
          this.getSchoolCurriculumList();
        }
      });
    },

    //查询校区账户列表
    getEducationalInstitutionAccountList() {
      getEducationalInstitutionAccountList({
        name: "",
        page_no: "1",
        page_size: "100",
      }).then((res) => {
        console.log("查询校区账户列表");
        console.log(res);
        this.PayAccountList = res.educationalinstitutionaccountList;
      });
    },

    //根据数据表名，从后台获取各个表的所有字段的相关信息
    fetchData() {
      this.$store
        .dispatch("getTableColumnInfo", this.tableName)
        .then((res) => {
          if (res.data.code == 1) {
            const allData = res.data.data;
            const data = [];
            for (let i = 0; i < allData.length; i++) {
              data.push({
                key: allData[i].rownum,
                label: allData[i].name,
                comment: allData[i].comment,
                tabname: allData[i].tabname,
              });
            }
            this.transferData = data;
          } else {
            this.$message.error("表字段查询失败");
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },

    //右侧列表元素变化时触发
    getObject() {
      console.log("选中所有数据" + this.checked);
    },

    submitClassDay(index) {


      if (!this.updateform.start_time) {
        this.$message.warning("请选择开始时间");
        return;
      }

      if (!this.updateform.end_time) {
        this.$message.warning("请选择结束时间");
        return;
      }

      this.educational_institution_class_day_list[index].start_class_date =
        this.updateform.start_time;
      this.educational_institution_class_day_list[index].end_class_date =
        this.updateform.end_time;
      this.addClassDay("保存成功", "update", index);


    },
    addClassDay(msg, status, index) {
      let class_day_list = this.educational_institution_class_day_list.map(
        (item) => {
          return {
            start: "2020-02-02 " + item.start_class_date,
            end: "2020-02-02 " + item.end_class_date,
          };
        }
      );

      console.log("添加的时段");
      console.log(class_day_list);

      class_day_list.sort(function (a, b) {
        return b.start > a.start ? -1 : 1;
      });

      console.log("排序的时段");
      console.log(class_day_list);

      addClassDay({
        class_day_list: JSON.stringify(class_day_list),
      }).then(() => {
        if (status === "update") {
          this.educational_institution_class_day_list[index].edit = false;
          this.classtime = null;
          console.log(this.classtime);
          this.getBaseInfo();
        }
        this.$message.success(msg);
      });
    },
    deleteClassDay(index) {
      this.$confirm("确定删除当前授课时段?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.educational_institution_class_day_list.splice(index, 1);
        this.addClassDay("删除成功");
      });
    },
    closeUpdateClassTime(index) {
      console.log(index);
      this.$set(
        this.educational_institution_class_day_list[index],
        "edit",
        false
      );
      this.classtime = null;
      this.getBaseInfo();
    },
    updateClassTime(index) {
      this.$set(
        this.educational_institution_class_day_list[index],
        "edit",
        true
      );

      this.updateform.start_time = this.educational_institution_class_day_list[index].start_class_date + ':00';
      this.updateform.end_time = this.educational_institution_class_day_list[index].end_class_date + ':00';

      console.log(this.updateform)

    },
    addClassTime() {
      this.educational_institution_class_day_list.unshift({
        start_class_date: "",
        end_class_date: "",
        edit: true,
      });
    },
    updateIsEncryption() {
      updateIsEncryption({
        is_encryption: this.is_encryption,
      }).then(() => {
        this.$message.success("修改成功");
      });
    },

    //获得校区的课程体系列表

    getSchoolCurriculumList() {
      getSchoolCurriculumList({
        subject_id: this.ruleForm.subject_id,
        teaching_type: this.ruleForm.teaching_type,
        curriculum_type: this.ruleForm.curriculum_type,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log("查询校区课程体系");
        console.log(res);

        this.tableData = res.curriculumListAuthList;
        this.total1 = res.total;
      });
    },

    //获得课程体系的授权信息
    getSchoolCampusCurriculumAuthData(id) {
      getSchoolCampusCurriculumAuthData({
        curriculum_id: id,
      }).then((res) => {
        console.log("查询课程体系的授权信息");
        console.log(res);
        // this.tableData = res.curriculumList;
        this.SchoolAutherData = res.schoolCampusList;
      });
    },

    UpdateCourseInfo(id, price) {
      this.dialogFormVisible = true;
      this.form.curriculum_id = id;
      this.form.curriculum_price = price;
    },

    //更新校区课程体系默认价格
    updateSchoolCurriculumPermissionPrice() {
      console.log(this.form);

      updateSchoolCurriculumPermissionPrice({
        curriculum_id: this.form.curriculum_id,
        price: this.form.curriculum_price,
      }).then((res) => {
        console.log("更新课程体系价格");
        console.log(res);

        if (res.is_update) {
          this.dialogFormVisible = false;
          this.$message.success("价格设置成功");
          this.getSchoolCurriculumList();
        }
      });
    },

    prepare(id) {
      this.$router.push({
        name: "prepare",
        query: {
          curriculumMaterial_id: id,
          backname: "admin-basic-settings",
          activeMenu: "5",
        },
      });
    },

    saveStopDay() {
      for (
        let i = 0;
        i < this.educational_institution_closing_day_list.length;
        i++
      ) {
        if (
          !this.educational_institution_closing_day_list[i].closing_date ||
          !this.educational_institution_closing_day_list[i].name
        ) {
          this.$message.warning("请填写日期或名称");
          return;
        }
      }
      let closing_day_list = this.educational_institution_closing_day_list.map(
        (item) => {
          return {
            date: item.closing_date,
            name: item.name,
          };
        }
      );
      addStopDay({
        closing_day_list: JSON.stringify(closing_day_list),
      }).then(() => {
        this.$message.success("保存成功");
        this.editStopDayShow = false;
      });
    },
    reduceStopDay(index) {
      this.educational_institution_closing_day_list.splice(index, 1);
    },
    addStopDay() {
      this.educational_institution_closing_day_list.push({
        closing_date: "",
        name: "",
      });
    },
    getBaseInfo() {
      getBaseInfo().then((res) => {
        this.educational_institution_closing_day_list =
          res.educational_institution_closing_day_list;
        this.educational_institution_class_day_list =
          res.educational_institution_class_day_list;

        console.log("学校上课时段");
        console.log(res.educational_institution_class_day_list);

        this.is_encryption = res.educational_institution_obj[0].is_encryption;
      });
    },
    deleteCampus(row) {
      this.$confirm("确定删除当前校区?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteEducationalInstitutionCampus({
          educational_institution_campus_id: row.id,
        }).then(() => {
          this.$message.success("删除校区成功！");
          this.getEducationalInstitutionCampusList();
          this.getSchoolRightInfo();
        });
      });
    },
    editName(row) {
      console.log("编辑校区");
      console.log(row);
      this.edit_educational_institution_campus_name = row.name;
      this.campus_teacher_num = row.max_teacher_num;

      this.edit_id = row.id;
      this.editDialogVisible = true;
    },

    editAccount(row) {
      this.$router.push({
        name: "payaccount",
        query: {
          cmd: "edit",
          account: row,
        },
      });
    },

    editEducationalInstitutionCampusName() {
      editEducationalInstitutionCampusName({
        educational_institution_campus_id: this.edit_id,
        educational_institution_campus_name:
          this.edit_educational_institution_campus_name,
        campus_max_teacher_num: this.campus_teacher_num,
      }).then(() => {
        this.$message.success("编辑分校成功");
        this.editDialogVisible = false;
        this.getEducationalInstitutionCampusList();
        this.getSchoolRightInfo();
      });
    },
    createCampus() {
      this.centerDialogVisible = true;
      this.campus_teacher_num = 0;
      this.educational_institution_campus_name = "";
    },

    createPayAccount() {
      this.$router.push({
        name: "payaccount",
        query: {
          cmd: "create",
        },
      });
    },

    getEducationalInstitutionCampusList() {
      getEducationalInstitutionCampusList().then((res) => {
        console.log("分校列表");
        console.log(res);
        this.campusTableData = res.educational_institution_campus_list;
      });
    },
    save() {
      addEducationalInstitutionCampus({
        name:
          this.educational_institution_campus_name,
        maxTeacherNum: this.campus_teacher_num,
      }).then((res) => {
        this.$message.success("新建校区成功！");
        console.log(res);

        if (res.is_create) {
          this.$store.commit(
            "SET_SELECTSCHOOL",
            this.$store.state.user.selected_schools.push(
              res.educational_institution_campus_id
            )
          );
        }

        this.centerDialogVisible = false;
        this.educational_institution_campus_name = "";
        this.getEducationalInstitutionCampusList();
        this.getSchoolRightInfo();
      });
    },

    //穿梭框
    handleChange(value, direction, movedKeys) {
      console.log(value, direction, movedKeys);

      console.log(value);
      console.log(direction);
      console.log(movedKeys);

      this.$message("授权成功");
    },

    //查询商品列表
    getGoodsList() {
      getGoodsList({
        name: this.form1.name,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log("商品列表");
        console.log(res);
        this.goodsList = res.goodsList;
        this.total = res.total;
      });
    },

    reSize() {
      console.log("重置");
      this.form = {};
      this.getGoodsList();
    },
    onSubmitSelect() {
      console.log("提交查询");

      this.getGoodsList();
    },
    gotoGoodsInfo(obj) {
      console.log(obj);
      this.$router.push({
        name: "edit-goods",
        query: {
          good: obj,
        },
      });
    },

    gotoCreateGoods() {
      // 创建商品
      this.$router.push({
        name: "add-goods",
      });
    },
    deleteGoods(id) {
      deleteGoods({
        goodsId: id,
      }).then((res) => {
        console.log("删除商品");
        console.log(res);
        if (res.is_delete) {
          this.$message.success("删除成功");
          this.getGoodsList();
        }
      });
    },

    //删除学校账户
    deleteEducationalInstitutionAccount(id) {
      deleteEducationalInstitutionAccount({
        educationalInstitutionAccountId: id,
      }).then((res) => {
        console.log("删除账户");
        console.log(res);
        if (res.is_delete) {
          this.$message.success("删除成功");
          this.getEducationalInstitutionAccountList();
        }
      });
    },

    //查询学校课程体系

    search() {
      this.page_no = 1;
      this.getSchoolCurriculumList();
    },

    handleSizeChange(val) {
      this.page_size = val;
      this.getGoodsList();
    },

    handleCurrentChange(val) {
      this.page_no = val;
      this.getGoodsList();
    },

    handleSizeChange1(val) {
      this.page_size1 = val;
      this.getSchoolCurriculumList();
    },

    handleCurrentChange1(val) {
      this.page_no1 = val;
      this.getSchoolCurriculumList();
    },
  },
};
</script>
  
<style lang="scss" scoped>
.mainNew {
  height: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.container {
  min-height: calc(100% - 30px);
  background-color: #ffffff;
  border-radius: 5px;
  margin: 10px;

  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;

  // width: 100%;
  // height: 100%;

  // min-width: 1000px;
  // overflow: hidden;

  .basic-settings-body {
    .create-campus {
    }

    .search-list {
      margin-top: 20px;
      display: inline-block;
    }
  }

  .editStopDayShow {
    padding: 1 5px 0;
  }

  .transfer-footer {
    margin-left: 20px;
    padding: 6px 5px;
  }

  .wechat {
    margin-top: 20px;

    .wechat_head {
      width: 50px;
      height: 50px;
    }

    .wechat_name {
      line-height: 40px;
      position: relative;
      display: inline-block;
      overflow: hidden;
      margin-left: 20px;
    }

    .wechat_label {
      line-height: 40px;
      position: relative;
      display: inline-block;
      overflow: hidden;
      margin-left: 20px;
      color: green;
      font-weight: bold;
    }

    .wechat_download {
      line-height: 40px;
      position: relative;
      display: inline-block;
      overflow: hidden;
      margin-left: 50px;
      color: #529dfe;
      font-weight: bold;
      cursor: pointer;
    }
  }
}
</style>
  
<style>
.el-transfer-panel {
  width: 40%;
}
</style>
  
  